"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleCompositionSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const CompositionType_1 = require("../enums/CompositionType");
const MaterialType_1 = require("../enums/MaterialType");
const ShapeType_1 = require("../enums/ShapeType");
exports.impossibleCompositionSchema = zod_1.z.object({
    type: zod_1.z.nullable(zod_1.z.nativeEnum(CompositionType_1.CompositionType)),
    shape: zod_1.z.nullable(zod_1.z.nativeEnum(ShapeType_1.ShapeType)),
    descriptionRaw: constants_1.defaultOptionalString,
    materials: zod_1.z.nullable(zod_1.z.array(zod_1.z.nativeEnum(MaterialType_1.MaterialType))),
    percentage: zod_1.z.nullable(zod_1.z.number().min(1).max(100)),
}).strict();
